import { Wrench, AlertTriangle, Clock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface MaintenanceScreenProps {
  message?: string;
  tenantName?: string;
}

export function MaintenanceScreen({ message, tenantName }: MaintenanceScreenProps) {
  const defaultMessage = "We're currently performing scheduled maintenance to improve your experience. Please check back shortly.";

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full shadow-xl border-orange-200">
        <CardContent className="pt-8 pb-8 px-8 text-center">
          {/* Animated Icon */}
          <div className="relative mb-6">
            <div className="w-24 h-24 mx-auto bg-orange-100 rounded-full flex items-center justify-center">
              <Wrench className="w-12 h-12 text-orange-600 animate-pulse" />
            </div>
            <div className="absolute -top-1 -right-1 left-0 right-0 mx-auto w-fit">
              <div className="bg-yellow-400 rounded-full p-1.5 animate-bounce">
                <AlertTriangle className="w-5 h-5 text-yellow-900" />
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Συντήρηση Συστήματος
          </h1>
          <p className="text-lg text-orange-600 font-medium mb-6">
            System Maintenance
          </p>

          {/* Tenant Name */}
          {tenantName && (
            <p className="text-sm text-gray-500 mb-4">
              {tenantName}
            </p>
          )}

          {/* Message */}
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <p className="text-gray-700 leading-relaxed">
              {message || defaultMessage}
            </p>
          </div>

          {/* Status Indicator */}
          <div className="flex items-center justify-center gap-2 text-sm text-gray-500 mb-6">
            <Clock className="w-4 h-4" />
            <span>Θα επιστρέψουμε σύντομα</span>
          </div>

          {/* Refresh Button */}
          <Button
            variant="outline"
            onClick={() => window.location.reload()}
            className="border-orange-300 text-orange-700 hover:bg-orange-50"
          >
            Ανανέωση Σελίδας
          </Button>

          {/* Footer */}
          <p className="mt-6 text-xs text-gray-400">
            Ευχαριστούμε για την κατανόησή σας
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
